function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionCouponFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.933 19.5a1.25 1.25 0 102.5 0V18a1.25 1.25 0 10-2.5 0v1.5zM13.183 15.25c-.69 0-1.25-.56-1.25-1.25v-1.5a1.25 1.25 0 112.5 0V14c0 .69-.56 1.25-1.25 1.25z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.183 5a3 3 0 00-3 3v4.034c0 .264.235.466.5.466a3.5 3.5 0 010 7c-.265 0-.5.201-.5.466V24a3 3 0 003 3h20a3 3 0 003-3v-4.034c0-.265-.235-.466-.5-.466a3.5 3.5 0 110-7c.265 0 .5-.201.5-.466V8a3 3 0 00-3-3h-20zm0 2.5a.5.5 0 00-.5.5v2.341a6.003 6.003 0 010 11.318V24a.5.5 0 00.5.5h5.75v-1a1.25 1.25 0 112.5 0v1h11.75a.5.5 0 00.5-.5v-2.341a6.003 6.003 0 010-11.318V8a.5.5 0 00-.5-.5h-11.75v1a1.25 1.25 0 11-2.5 0v-1h-5.75z",
    fill: props.color
  }));
}

export default SvgIconPromotionCouponFilled;